
if (!customElements.get("custom-dropdown")) {
  class CustomDropdown extends HTMLElement {
    constructor() {
      super();
      this.trigger = null;
      this.contentWrapper = null;
      this.allOpenedDropdowns = null;
      this.boundToggleOptions = this.toggleOptions.bind(this);
      this.OPEN_ONE_AT_TIME = this.hasAttribute('one-at-time');
      this.ENABLE_ANIMATION = this.hasAttribute('animate');
      this.CONTENT_OFFSET = this.getAttribute('content-offset');
    }

    connectedCallback() {
      this.trigger = this.querySelector('[action-trigger]');
      this.contentWrapper = this.querySelector('[content]');
      if (!this.trigger || !this.contentWrapper) return;

      this.setupAccessibility();
      this.attachEvents();
    }

    disconnectedCallback() {
      if (!this.trigger) return;
      this.trigger.removeEventListener('click', this.boundToggleOptions);
    }

    attachEvents() {
      this.trigger.addEventListener('click', this.boundToggleOptions);
    }

    setupAccessibility() {
      const accordionId = this.dataset.accordionId;

      if (!this.contentWrapper.id && accordionId) {
        this.contentWrapper.id = `custom-dropdown-content-${accordionId}`;
      }

      if (this.contentWrapper.id) {
        this.trigger.setAttribute('aria-controls', this.contentWrapper.id);
      }

      this.syncAriaState(this.hasAttribute('open'));
    }

    syncAriaState(isOpen) {
      this.trigger.setAttribute('aria-expanded', String(isOpen));
      this.contentWrapper.setAttribute('aria-hidden', String(!isOpen));
    }

    announceState(isOpen) {
      const liveRegionId = 'custom-dropdown-live-region';
      let liveRegion = document.getElementById(liveRegionId);

      if (!liveRegion) {
        liveRegion = document.createElement('div');
        liveRegion.id = liveRegionId;
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.className = 'visually-hidden';
        document.body.appendChild(liveRegion);
      }

      const label = this.trigger.textContent.trim();
      liveRegion.textContent = `${label} ${isOpen ? 'expanded' : 'collapsed'}`;
    }

    calculateOptionsContainerHeight(select) {
      const height = select.contentWrapper.scrollHeight;
      if (select.hasAttribute('open')) {
        select.contentWrapper.style.height = `${height + Number(this.CONTENT_OFFSET)}px`;
      } else {
        select.contentWrapper.style.height = '0';
      }
    }

    open(dropdown) {
      dropdown.setAttribute('open', '');
      if (this.ENABLE_ANIMATION) this.calculateOptionsContainerHeight(dropdown);
      dropdown.syncAriaState(true);
      dropdown.announceState(true);
    }

    close(dropdown) {
      dropdown.removeAttribute('open');
      if (this.ENABLE_ANIMATION) this.calculateOptionsContainerHeight(dropdown);
      dropdown.syncAriaState(false);
      dropdown.announceState(false);
    }

    toggleOptions() {
      if (this.OPEN_ONE_AT_TIME) {
        this.allOpenedDropdowns = document.querySelectorAll(this.classList);
        this.allOpenedDropdowns.forEach(dropdown => {
          if (dropdown != this) this.close(dropdown);
        });
      }

      this.hasAttribute('open')
        ? this.close(this)
        : this.open(this);
    }
  }

  customElements.define('custom-dropdown', CustomDropdown);
}
